import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Unsplash from '../page/Unsplash'; 

class UnsplashPortal extends Component {

  constructor(props:any){
    super(props);  
    (window as any).reMountUnsplashPortal = this;
  }

  reBind(){
    // Force a render/check from outside JS (CMS) when portal is now available
    this.forceUpdate();
  }

  render() {

    // Container ref
    const targetContainer = document.getElementById('react-unsplash-container');
    
    // Dont load if container doesnt exist
    if (targetContainer === null){
        return null;
    }

    return ReactDOM.createPortal(
      <Unsplash />, targetContainer
    );
  }
}

export default UnsplashPortal;